// export  const MainWebsiteUrl = "http://localhost:8080";
// export const Api_ENDPOINT = "http://localhost:35544";
// export const Form_Api_ENDPOINT = "https://crm.zoho.in/crm/WebToLeadForm";
// export const IMAGE_MAIN_ENDPOINT = "https://spdevlogsstorage.blob.core.windows.net/main/";
// export const IMAGE_THUMBNAIL_ENDPOINT = "https://spdevlogsstorage.blob.core.windows.net/thumbnail/";

export const MainWebsiteUrl = "https://mainsite-managementconsole-react.azurewebsites.net";
export const Api_ENDPOINT = "https://mainsite-publicapi.azurewebsites.net";
export const Form_Api_ENDPOINT = "https://crm.zoho.in/crm/WebToLeadForm";
export const IMAGE_MAIN_ENDPOINT = "https://cms-assets.superplum.com/cmsmain/";
export const IMAGE_THUMBNAIL_ENDPOINT = "https://cms-assets.superplum.com/cmsthumbnails/";



export const GoogleMapAPI ="AIzaSyA2of8I7sr_6MzWzuvE0yPm6gAKrDXEQHA";
export const StoreLocatorAPI = "https://publicapi.freshmanager.in/";
export const pageSize = 2147483647;